import { Observable } from "rxjs";
import {BrokerContactType} from "../application-service.domain";

export type SalesforceContactSameAccountSelectionValue = BrokerContactType | null;


export type GetSalesforceContactSameAccountFunc = (salesforceAccountId: string) => Observable<BrokerContactType[]>;
